import { isLoginFromSoilApp } from "./globals/authentication";

/* global process */
export const attemptAppRedirect = () => {
  const isMobile =
    /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
  const isProduction = process.env.REACT_APP_ENV === "production";
  const isSoilAppLogin = isLoginFromSoilApp();
  const isMobileApp = window.ReactNativeWebView || isSoilAppLogin;

  // Don't redirect if already in PWA mode
  if (isStandalone) return;

  const isAndroid = /Android/i.test(navigator.userAgent);

  if (isMobile && isProduction && isAndroid && !isMobileApp) {
    // Redirect only for Android devices
    const currentPath = window.location.pathname + window.location.search;
    const appURL = `farmapp://${currentPath.substring(1)}`; // Remove leading slash

    // Show a user-friendly prompt
    const userWantsApp = confirm("Open in FarmApp mobile app?");

    if (userWantsApp) {
      window.location.href = appURL;

      // Fallback: redirect to app store if app doesn't open
      setTimeout(() => {
        if (!document.hidden) {
          const appStoreURL =
            "https://play.google.com/store/apps/details?id=in.asqi.farmapp2";
          window.location.href = appStoreURL;
        }
      }, 2000);
    }
  }
};
